<ws10-paragraph *ngIf="paragrapghConfig" [paragrapghConfig]="paragrapghConfig"></ws10-paragraph>
